<template>
  <a-layout-sider
    theme="dark"
    collapsible
    breakpoint="lg"
    v-model="collapsed"
  >
    <div class="div-center">
      <a href="https://manage.example.org/">
        <img src="https://static.axioms.io/branding/favicon.svg" class="logo-dashboard" alt="Axioms" />
      </a>
    </div>
    <a-menu theme="dark" mode="inline" @click="handleClick">
      <a-menu-item key="1">
        <a-icon type="home"></a-icon>
        <span>Home</span>
      </a-menu-item>
      <a-menu-item key="2" v-show="$role(['tenant:owner']) && belongsToOrg">
        <a-icon type="cloud"></a-icon>
        <span>Tenant</span>
      </a-menu-item>
      <a-menu-item key="3" v-show="$role(['tenant:owner', 'client:admin']) && belongsToOrg">
        <a-icon type="deployment-unit"></a-icon>
        <span>Clients</span>
      </a-menu-item>
      <a-menu-item key="4" v-show="$role(['tenant:owner', 'resource:admin']) && belongsToOrg">
        <a-icon type="api"></a-icon>
        <span>Resources</span>
      </a-menu-item>
      <a-menu-item key="5" v-show="$role(['tenant:owner', 'role:admin']) && belongsToOrg">
        <a-icon type="usergroup-add"></a-icon>
        <span>Roles</span>
      </a-menu-item>
      <a-menu-item key="6" v-show='$role(["tenant:owner", "user:admin"]) && belongsToOrg'>
        <a-icon type="team"></a-icon>
        <span>Users</span>
      </a-menu-item>
      <a-menu-item key="7" v-show='$role(["tenant:owner", "webhook:admin"]) && belongsToOrg'>
        <a-icon type="thunderbolt"></a-icon>
        <span>Webhooks</span>
      </a-menu-item>
      <a-menu-item key="8" v-show='$role(["tenant:owner", "key:admin"]) && belongsToOrg'>
        <a-icon type="key"></a-icon>
        <span>Keys</span>
      </a-menu-item>
      <a-menu-item key="9" v-show='$role(["tenant:owner", "subscription:admin"]) && belongsToOrg'>
        <a-icon type="dollar"></a-icon>
        <span>Subscription</span>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
</template>

<script>
export default {
  name: "a-sidebar",
  data() {
    return {
      collapsed: false
    };
  },
  methods: {
    // eslint-disable-next-line
    handleClick({ key }) {
      switch (key) {
        case "1":
          this.$router.push("/");
          break;
        case "2":
          this.$router.push("/tenant");
          break;
        case "3":
          this.$router.push("/clients");
          break;
        case "4":
          this.$router.push("/resources");
          break;
        case "5":
          this.$router.push("/roles");
          break;
        case "6":
          this.$router.push("/users");
          break;
        case "7":
          this.$router.push("/webhooks");
          break;
        case "8":
          this.$router.push("/keys");
          break;
        case "9":
          this.$router.push("/subscription");
          break;
        default:
          this.$router.push("/");
          break;
      }
    }
  },
  computed: {
    userroles() {
      return this.$store.state.tenant.usertoroles
        ? this.$store.state.tenant.usertoroles.map(record => record.role)
        : [];
    },
    belongsToOrg() {
      return this.$auth.session.org && this.$auth.session.org !== "false" ? true : false;
    },
    collapsedCss() {
      if (this.collapsed) {
        return { overflow: 'auto', height: '100vh', position: 'fixed', left: 0 }
      }
      else {
        return { left: 0 }
      }
    }
  },
  beforeCreate: async function() {
    try {
      if (this.$auth.session.org && this.$auth.session.org === "false") {
        throw new TypeError("Tenant UUID is not valid");
      }
      await this.$store.dispatch("axioms/getItems", {
        endpoint: "usertoroles",
        params: { user: this.$auth.session.id_payload.sub, organization: this.$auth.session.org }
      });
    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style lang="css">
.logo-dashboard {
  width: 35%;
  display: inline-block;
}

.ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
    color: #002e66 !important;
    background-color: white !important;
}
</style>
